import { ICaseInfoUpdateModel } from "../Interfaces/ICaseInfoUpdate";

export const CaseInfoUpdateModel:ICaseInfoUpdateModel = {
    data:undefined,
    error:false,
    isLoading:false,
    isEditing:false
}